import { render, staticRenderFns } from "./Book-index.vue?vue&type=template&id=0b8b7fa2&scoped=true"
import script from "./Book-index.vue?vue&type=script&lang=js"
export * from "./Book-index.vue?vue&type=script&lang=js"
import style0 from "./Book-index.vue?vue&type=style&index=0&id=0b8b7fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b7fa2",
  null
  
)

export default component.exports